import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Row, Col, Input, Button, Affix, Spin, message as Message } from 'antd';
import { MdSend } from 'react-icons/md';
import { Location } from 'history';
import _ from 'lodash';
import i18n from 'i18next';

import { PageHeader } from '../layout/PageHeader';
import { Messages } from './Messages';
import { colors } from '../../constants/colors';

import { sendMessage, getChatDetails, getChat } from '../../store/chat/actions';
import { getChatState } from '../../store/chat/selector';
import { ChatProps, Sender } from '../../store/chat/types';
import { getUserState } from '../../store/user/selector';
import { fnCheckForRestrictedWords } from '../../constants/resctrictedWords';

export interface LocationProps {
  user: Sender;
  chatid?: string;
}

export const ChatMessage: React.FC = () => {
  const [message, setMessage] = useState<string>('');
  const { chat, isLoading } = useSelector(getChatState);
  const { user } = useSelector(getUserState);

  const dispatch = useDispatch();
  const location: Location<LocationProps> = useLocation();
  const { state } = location;
  const [receiver, setReceiver] = useState<LocationProps>();
  const [chatItems, setChatItems] = useState<ChatProps | undefined>();

  const chatRef = React.useRef(true);

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(e.target.value);
  };

  const handleSendMessage = () => {
    console.log(message);
    if (fnCheckForRestrictedWords(message)) {
      Message.error(i18n.t('RESCTRICTED_MESSAGE'));
      return;
    }
    if (receiver?.chatid) {
      const chat = { message, id: receiver?.chatid };
      dispatch(sendMessage(chat));
    } else {
      const chat = { message, receiver: receiver?.user.id };
      dispatch(sendMessage(chat));
    }
    setMessage('');
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter' && message.length !== 0) {
      handleSendMessage();
    }
  };

  useEffect(() => {
    if (state) {
      setReceiver(state);
    }
  }, [state]);

  useEffect(() => {
    if (user.userid && _.isEmpty(chat) && chatRef.current) {
      dispatch(getChat());
      dispatch(getChatDetails());
      chatRef.current = false;
    }
  }, [chat, chatRef, state, user, dispatch]);

  useEffect(() => {
    const findchat = chat && _.find(chat, c => c.sender.id === state?.user.id);
    if (user.userid && findchat) {
      setReceiver({ user: state.user, chatid: findchat.id });
      setChatItems(findchat);
      if (chatRef.current) {
        chatRef.current = false;
      }
    }
  }, [chat, state, user, dispatch]);

  return (
    <div className="dashboard">
      <PageHeader
        avatar={receiver ? receiver.user.image : chatItems?.sender.image}
        headerTitle={receiver ? receiver.user.firstName : ''}
      />
      <Row justify="center" className="chat-message-container">
        <Col
          xs={24}
          sm={24}
          md={14}
          lg={10}
          xl={10}
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <Col span={24} className="chat-messages">
            {isLoading ? (
              <Row justify="center" className="spinner-container loading">
                <Spin />
              </Row>
            ) : (
              <Messages chat={chatItems} />
            )}
          </Col>

          <Affix offsetBottom={0}>
            <Col span={24} className="chat-box-container">
              <Input
                value={message}
                placeholder="Type your message…"
                onChange={onInputChange}
                onKeyDown={handleKeyDown}
              />
              <Button
                type="link"
                disabled={_.isEmpty(message)}
                onClick={handleSendMessage}
              >
                <MdSend
                  color={
                    _.isEmpty(message) ? colors.disabledPrimaryColor : '#27aae1'
                  }
                  size={22}
                />
              </Button>
            </Col>
          </Affix>
        </Col>
      </Row>
    </div>
  );
};
